import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/config/app";
import type { PaginationParams } from "@/types/api";
import { buildUrl } from "@/utils/buildUrl";

import type { DinerPath, RestaurantDinerResponse } from "./types";

const fetchDiners = async (
  path: string,
  params?: Partial<PaginationParams>
) => {
  const url = buildUrl(API_ENDPOINTS.RESTAURANTS, `/diners/${path}`, params);
  return await apiClient.get<RestaurantDinerResponse>(url);
};

export const apiRestaurantDiners = {
  getById: (type: DinerPath, id: string, params?: Partial<PaginationParams>) =>
    fetchDiners(`${type}/${id}`, params),

  getAll: (
    type: Extract<DinerPath, DinerPath.BRAND | DinerPath.BRANCH>,
    params?: Partial<PaginationParams>
  ) => fetchDiners(`${type}/all`, params),
};
